// Leaderboard.jsx

import React, { useEffect, useState } from "react";
import axios from "../../../axios";
import { Trophy, Crown } from "lucide-react";
import { FaCoins } from "react-icons/fa";
import ProfileAvatar from "../../../componant/Avatar/ProfileAvatar";
import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";

const tabs = [
  { label: "OVERALL", value: "all" },
  { label: "CONTEST", value: "contest" },
  { label: "QUIZ", value: "quiz" },
];

function Leaderboard() {
  const [activeTab, setActiveTab] = useState("all");
  const [leaderboard, setLeaderboard] = useState([]);
  const [loginUser, setLoginUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLeaderboard();
  }, [activeTab]);

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);

      // login user id
      const userId = localStorage.getItem("userId");

      const res = await axios.get(
        `/getLeaderboardForAdmin?filter=${activeTab.toLowerCase()}`,
      );

      setLeaderboard(res?.data?.result?.topUsers || []);
      setLoginUser(res?.data?.result?.loginUser);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const topThree = leaderboard.slice(0, 3);
  //   console.log(topThree[0]?.profileImage,"toppppppppppp")
  const remainingUsers = leaderboard.slice(3);

  const getScore = (user) => {
    let score = 0;

    if (activeTab === "quiz") {
      score = user?.lifetimeEarned || 0;
    } else if (activeTab === "contest") {
      score = user?.lifetimeContestEarned || 0;
    } else {
      score = user?.totalScore || 0;
    }

    return Number(score).toFixed(2);
  };

  const renderLastActivity = (user) => (
    <div
      className={`mt-1 flex items-center justify-center gap-1 text-[10px] font-medium ${
        user?.isLastTransactionEarned ? "text-green-600" : "text-red-500"
      }`}
    >
      {user?.isLastTransactionEarned ? (
        <FaArrowTrendUp size={10} />
      ) : (
        <FaArrowTrendDown size={10} />
      )}

      <span>
        {user?.isLastTransactionEarned ? "+" : "-"}
        {Math.abs(user?.lastTransactionAmount || 0)}
      </span>
    </div>
  );

  return (
<div className="min-h-screen overflow-x-hidden bg-[#F7F4FF] pb-24 pt-3 lg:pb-10 lg:pt-0">
     {/* HEADER */}
      {/* <div className="rounded-b-[30px] bg-[#4B148A] px-4 py-2 pb-2 pt-2 lg:pb-8"> */}
      <div className="mx-auto max-w-7xl">
        {/* TOP BAR */}
        {/* <div className="flex items-center justify-between">
          <button className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow">
            ←
          </button>

          <div className="text-center">
            <h1 className="text-xl font-bold text-white lg:text-3xl">
              Adhyayi
            </h1>

            <p className="text-xs text-purple-100 lg:text-sm">
              Learn. Play. Win.
            </p>
          </div>

          <button className="flex h-11 w-11 items-center justify-center rounded-full bg-white shadow">
            i
          </button>
        </div> */}

        {/* TABS */}
        <div className="mt-5 flex justify-center">
          <div className="overflow-hidden rounded-[22px] bg-white p-1 shadow-lg">
            <div className="flex items-center">
              {tabs.map((tab) => (
                <button
                  key={tab.value}
                  onClick={() => setActiveTab(tab.value)}
                  className={`min-w-[110px] px-6 py-3 text-xs font-bold transition-all duration-300 lg:min-w-[180px] lg:px-10 lg:py-4 lg:text-base ${
                    activeTab === tab.value
                      ? "rounded-[18px] bg-[#5B1FA6] text-white shadow-md"
                      : "text-[#3E2466]"
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      <div className="mx-auto max-w-7xl px-3 lg:px-6">
        {/* LOADING */}
        {loading && (
          <div className="py-20 text-center text-gray-500">
            Loading leaderboard...
          </div>
        )}

        {!loading && (
          <>
            {/* ================= TOP 3 ================= */}

            {/* MOBILE */}
            <div className="mt-3 block lg:hidden">
              <div className="flex items-end justify-center gap-2 rounded-[20px] bg-white px-3 py-4 shadow-sm">
                {/* SECOND */}
                {topThree[1] && (
                  <div className="min-w-0 flex-1 rounded-[18px] border border-[#E8DDFB] bg-white px-2 pb-3 pt-2 text-center shadow-sm">
                    <div className="relative mx-auto w-fit">
                      <Crown
                        className="absolute -top-4 left-1/2 -translate-x-1/2 text-gray-400"
                        size={22}
                      />

                      <ProfileAvatar
                        user={topThree[1]}
                        className="flex h-12 w-12 shrink-0 text-sm"
                      />

                      <div className="absolute -bottom-2 left-1/2 flex h-6 w-6 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white bg-[#ECE8FF] text-xs font-bold text-[#25114D] shadow">
                        2
                      </div>
                    </div>

                    <h3 className="mt-4 line-clamp-1 text-xs font-bold text-[#25114D]">
                      {topThree[1]?.name}
                    </h3>

                    <div className="mt-1 flex items-center justify-center gap-1 text-xs font-bold text-[#25114D]">
                      <FaCoins className="text-yellow-500" size={13} />
                      <span className="truncate">{getScore(topThree[1])}</span>
                    </div>
                    <p className="text-[10px] text-orange-500">Credits</p>
                    {renderLastActivity(topThree[1])}
                  </div>
                )}

                {/* FIRST */}
                {topThree[0] && (
                  <div className="relative min-w-0 flex-[1.15] rounded-[22px] bg-gradient-to-b from-[#7B2FF7] to-[#3B0A80] px-2 pb-4 pt-3 text-center shadow-xl">
                    <div className="relative mx-auto w-fit">
                      <Crown
                        className="absolute -top-5 left-1/2 -translate-x-1/2 text-yellow-400"
                        size={28}
                      />

                      <ProfileAvatar
                        user={topThree[0]}
                        className="flex h-14 w-14 shrink-0 text-base"
                      />

                      <div className="absolute -bottom-2 left-1/2 flex h-7 w-7 -translate-x-1/2 items-center justify-center rounded-full border-2 border-[#FFCF53] bg-yellow-400 text-sm font-bold text-[#25114D] shadow-lg">
                        1
                      </div>
                    </div>

                    <h3 className="mt-5 line-clamp-1 text-sm font-bold text-white">
                      {topThree[0]?.name}
                    </h3>

                    <div className="mt-2 flex items-center justify-center gap-1 text-sm font-bold text-white">
                      <FaCoins className="text-yellow-400" size={16} />
                      <span className="truncate">{getScore(topThree[0])}</span>
                    </div>
                    <p className="text-[10px] text-orange-500">Credits</p>
                    {renderLastActivity(topThree[0])}
                  </div>
                )}

                {/* THIRD */}
                {topThree[2] && (
                  <div className="min-w-0 flex-1 rounded-[18px] border border-[#F7E4D7] bg-[#FFF8F4] px-2 pb-3 pt-2 text-center shadow-sm">
                    <div className="relative mx-auto w-fit">
                      <Crown
                        className="absolute -top-4 left-1/2 -translate-x-1/2 text-orange-400"
                        size={22}
                      />

                      <ProfileAvatar
                        user={topThree[2]}
                        className="flex h-12 w-12 shrink-0 text-sm"
                      />

                      <div className="absolute -bottom-2 left-1/2 flex h-6 w-6 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white bg-[#FFE7D7] text-xs font-bold text-[#25114D] shadow">
                        3
                      </div>
                    </div>

                    <h3 className="mt-4 line-clamp-1 text-xs font-bold text-[#25114D]">
                      {topThree[2]?.name}
                    </h3>

                    <div className="mt-1 flex items-center justify-center gap-1 text-xs font-bold text-[#25114D]">
                      <FaCoins className="text-yellow-500" size={13} />
                      <span className="truncate">{getScore(topThree[2])}</span>
                    </div>
                    <p className="text-[10px] text-orange-500">Credits</p>
                    {renderLastActivity(topThree[2])}
                  </div>
                )}
              </div>
            </div>

            {/* DESKTOP */}
            {/* ================= DESKTOP LAYOUT ================= */}
          <div className="mt-6 hidden h-[calc(100vh-180px)] flex-col lg:flex">
                 {/* RIGHT SIDE */}
<div className="flex min-h-0 flex-1 flex-col rounded-[20px] bg-white p-4">
                <h2 className="mb-3 text-center text-xl font-bold text-[#25114D]">
                  Top Winners
                </h2>
                {/* TOPPERS */}
                <div className="flex h-[240px] items-end justify-center gap-4">
                  {/* SECOND */}
                  {topThree[1] && (
                    <div className="mb-2 w-full max-w-[180px] rounded-[26px] bg-white px-4 py-2 text-center shadow-lg">
                      <div className="flex justify-center">
                        <ProfileAvatar
                          user={topThree[1]}
                          className="h-12 w-12 text-xl"
                        />
                      </div>

                      <div className="mt-3 text-2xl font-bold text-[#25114D]">
                        2
                      </div>

                      <h2 className="mt-2 line-clamp-1 text-md font-bold text-[#25114D]">
                        {topThree[1]?.name}
                      </h2>

                      <div className="mt-4 flex items-center justify-center gap-2 text-xl font-bold text-[#25114D]">
                        <FaCoins className="text-yellow-500" />
                        {getScore(topThree[1])}
                      </div>
                      <p className="text-[10px] text-orange-500">Credits</p>
                      {renderLastActivity(topThree[1])}
                    </div>
                  )}

                  {/* FIRST */}
                  {topThree[0] && (
                    <div className="relative w-full max-w-[260px] rounded-[28px] bg-gradient-to-b from-[#6E27D9] to-[#3E0B83] px-6 py-6 text-center text-white shadow-2xl">
                      <Crown
                        className="absolute -top-3 left-1/2 -translate-x-1/2 text-yellow-400"
                        size={36}
                      />

                      <div className="flex justify-center">
                        <ProfileAvatar
                          user={topThree[0]}
                          className="h-12 w-12 text-xl border-[3px] border-yellow-400"
                        />
                      </div>

                      <div className="mt-2 text-xl font-bold">1</div>

                      <h2 className="mt-3 line-clamp-1 text-xl font-bold">
                        {topThree[0]?.name}
                      </h2>

                      <div className="mt-4 flex items-center justify-center gap-2 text-lg font-bold">
                        <FaCoins className="text-yellow-400" />
                        {getScore(topThree[0])}
                      </div>
                      <p className="text-[10px] text-orange-500">Credits</p>
                      {renderLastActivity(topThree[0])}
                    </div>
                  )}

                  {/* THIRD */}
                  {topThree[2] && (
                    <div className="mb-5 w-full max-w-[200px] rounded-[24px] bg-[#FFF8F4] px-4 py-4 text-center shadow-lg">
                      <div className="flex justify-center">
                        <ProfileAvatar
                          user={topThree[2]}
                          className="h-12 w-12 text-lg"
                        />
                      </div>

                      <div className="mt-3 text-2xl font-bold text-[#25114D]">
                        3
                      </div>

                      <h2 className="mt-2 line-clamp-1 text-lg font-bold text-[#25114D]">
                        {topThree[2]?.name}
                      </h2>

                      <div className="mt-2 flex items-center justify-center gap-2 text-xl font-bold text-[#25114D]">
                        <FaCoins className="text-yellow-500" />
                        {getScore(topThree[2])}
                      </div>
                      <p className="text-[10px] text-orange-500">Credits</p>
                      {renderLastActivity(topThree[2])}
                    </div>
                  )}
                </div>

                {/* LIST */}
                <div className="mt-2 flex-1 overflow-y-auto rounded-[26px] bg-white shadow-sm min-h-0">
                  {/* HEADER */}
                  <div className="sticky top-0 z-10 grid grid-cols-[100px_1fr_150px] border-b bg-[#FAF7FF] px-8 py-5 text-sm font-bold text-gray-500">
                    <div>Rank</div>
                    <div>Student</div>
                    <div className="text-right">Score</div>
                  </div>

                  {remainingUsers.map((user, index) => (
                    <div
                      key={user.userId}
                      className="grid grid-cols-[100px_1fr_150px] items-center border-b px-8 py-2"
                    >
                      {/* RANK */}
                      <div className="text-xl font-bold text-[#25114D]">
                        {index + 4}
                      </div>

                      {/* USER */}
                      <div className="flex items-center gap-4">
                        <ProfileAvatar
                          user={user}
                          className="flex h-10 w-10 text-lg"
                        />

                        <div>
                          <h3 className="text-lg font-bold text-[#25114D]">
                            {user?.name}
                          </h3>

                          <p className="text-sm text-gray-500">{user?.email}</p>
                        </div>
                      </div>

                      {/* SCORE */}
                      <div className="text-right">
                        <div className="flex items-center justify-end gap-2 text-xl font-bold text-[#25114D]">
                          <FaCoins className="text-yellow-500" />
                          {getScore(user)}
                        </div>
                        <p className="text-[10px] text-orange-500">Credits</p>
                        <div className="pl-10"> {renderLastActivity(user)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
           
            {/* TABLE */}
<div className="mx-auto mt-4 flex max-h-[48vh] flex-col overflow-hidden rounded-[24px] bg-white shadow-sm lg:hidden">
                {/* HEADER */}
              <div className="grid grid-cols-[48px_minmax(0,1fr)_92px] border-b bg-[#FAF7FF] px-3 py-3 text-xs font-bold text-gray-500">
                <div>Rank</div>
                <div>Student</div>
                <div className="text-right">Score</div>
              </div>{" "}
             
  {/* Scrollable List Only */}
  <div className="flex-1 overflow-y-auto pb-5">
    {remainingUsers.map((user, index) => (
      <div
        key={user.userId}
        className="grid grid-cols-[48px_minmax(0,1fr)_92px] items-center gap-2 border-b px-3 py-2 last:border-none"
      >
                  {/* LEFT */}
                    {/* RANK */}
                  <div className="text-base font-bold text-[#25114D]">
                    {index + 4}
                  </div>

                  <div className="flex min-w-0 items-center gap-2">
                    {/* AVATAR */}
                    <ProfileAvatar
                      user={user}
                      className="flex h-10 w-10 shrink-0 text-sm"
                    />
                    {/* INFO */}
                    <div className="min-w-0">
                      <h3 className="truncate text-sm font-bold text-[#25114D]">
                        {user?.name}
                      </h3>
                      <p className="mt-1 truncate text-[11px] text-gray-500">
                        {user?.email}
                      </p>
                    </div>
                  </div>
                  {/* SCORE */}
                  <div className="min-w-0 text-right">
                    <div className="flex items-center justify-end gap-1 text-sm font-bold text-[#25114D]">
                      <FaCoins className="shrink-0 text-yellow-500" size={15} />
                      <span className="truncate">{getScore(user)}</span>
                    </div>
                    <p className="text-[10px] text-orange-500">Credits</p>
                    <div className="flex justify-end">{renderLastActivity(user)}</div>
                  </div>
                </div>
              ))}
              </div>
            </div>
           
          </>
        )}
      </div>
    </div>
  );
}

export default Leaderboard;
